import { render } from "./HomeProjects.vue?vue&type=template&id=64c3c3f3&scoped=true"
const script = {}

import "./HomeProjects.vue?vue&type=style&index=0&id=64c3c3f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c3c3f3"]])

export default __exports__